import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-white px-5 py-6 sm:py-12" data-id="element-170" data-mp="22l5dz2tolmka">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-171" data-mp="22mq3uf51whbt">
        <span className="mb-4 inline-block rounded-full border border-cobalt/40 bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep sm:mb-5" data-id="element-172" data-mp="2gdlfu0aujejm">
          Ce que contient la bibliothèque
        </span>
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-173" data-mp="2bllcryzhc5it">
          Théorie, activités, évaluations et corrigés réunis dans une seule bibliothèque.
        </h2>
        <p className="mt-3 text-sm font-medium text-cobalt-deep sm:mt-5 sm:text-lg" data-id="element-174" data-mp="342xql4ltnuo1">
          CHIMIE VISUELLE™ — la bibliothèque pédagogique de chimie pensée pour les professeurs de
          physique-chimie
        </p>
        <div className="mx-auto mt-4 h-px w-16 bg-cobalt/40 sm:mt-6" data-id="element-175" data-mp="phn4u3g3cd40" />
        <p className="mt-4 text-sm leading-relaxed text-ink/70 sm:mt-6 sm:text-base" data-id="element-176" data-mp="1458ao54coqfm">
          5 volumes pédagogiques de 60 pages et 4 ressources complémentaires, soit 460 pages :
          schémas, fiches visuelles, séquences, activités, exercices, évaluations, corrigés et
          parcours de différenciation. Vous ne recevez pas des fichiers isolés, mais un ensemble
          organisé, prêt à imprimer ou à projeter.
        </p>
      </motion.div>
    </section>;
}